var map = {
	"./al.json": 1319,
	"./ar.json": 1320,
	"./bg.json": 1321,
	"./br.json": 1322,
	"./en.json": 1323,
	"./es.json": 1324,
	"./hu.json": 1325,
	"./it.json": 1326,
	"./ko.json": 1327,
	"./mk.json": 1328,
	"./pl.json": 1329,
	"./pt.json": 1330,
	"./ru.json": 1331,
	"./sr.json": 1332,
	"./uk.json": 1333,
	"./vn.json": 1334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1318;


//////////////////
// WEBPACK FOOTER
// ./src/data/languages ^\.\/.*\.json$
// module id = 1318
// module chunks = 0